module.exports = __webpack_public_path__ + "img/2_283.5e3882ee.png";